import { storeData } from '../../store';

// Get ID
export const _getPrimeCategoryId = name => {
    for (const el of storeData.primeCategories) {
        if (el.name.trim() === name.trim()) {
            return el.id;
        }
    }
    return '';
};
export const _getCategoryId = name => {
    console.log(name);
    for (const el of storeData.categories) {
        if (el.name.trim() === name.trim()) {
            return el.id;
        }
    }
    return '';
};
export const _getSubCategoryId = name => {
    for (const el of storeData.subCategories) {
        if (el.name.trim() === name.trim()) {
            return el.id;
        }
    }
    return '';
};

export const _getVendorId = vendor_name => {
    for (const el of storeData.vendorDataList) {
        if (el.vendor_name.trim() === vendor_name.trim) {
            return el.id;
        }
    }
    return '';
};

// Get Name
export const _getPrimeCategoryName = id => {
    for (const el of storeData.primeCategories) {
        if (el.id == id) return el.name;
    }
};
export const _getCategoryName = id => {
    for (const el of storeData.categories) {
        if (el.id == id) return el.name;
    }
};
export const _getSubCategoryName = id => {
    for (const el of storeData.subCategories) {
        if (el.id == id) return el.name;
    }
};
export const _getVendorName = id => {
    for (const el of storeData.vendorDataList) {
        if (el.id == id) return el.vendor_name;
    }
};

export const getMoneyFormat = number => {
    const val = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(~~number);
    let num = '';
    for (const el of val) {
        if (el == '.') break;
        num += el;
    }
    return num;
};

const parseAmountToInt = amountString => {
    let amountInt = amountString?.replaceAll('$', '');
    amountInt = amountInt.replaceAll(',', '');
    return parseInt(amountInt) || 0;
};

const removeDecimals = val => {
    let num = '';
    for (const el of val) {
        if (el == '.') break;
        num += el;
    }
    return num;
};

const sortByMonth = arr => {
    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];
    const sorter = (a, b) => {
        if (a !== b) {
            return a - b;
        } else {
            return months.indexOf(a.month) - months.indexOf(b.month);
        }
    };
    arr.sort(sorter);
};

export default {
    _getCategoryId,
    _getCategoryName,
    _getPrimeCategoryId,
    _getPrimeCategoryName,
    _getSubCategoryId,
    _getSubCategoryName,
    _getVendorId,
    _getVendorName,
    getMoneyFormat,
    parseAmountToInt,
    removeDecimals,
    sortByMonth
};
